import {ref} from 'vue';

export const usePagination = (perPage = 5) => {
  const currentPages = ref({});

  const getPaginationCount = (category, totalItems) => {
    const currentPage = currentPages.value[category] || 1;
    const startCount = ((currentPage - 1) * perPage) + 1;
    const endCount = Math.min(currentPage * perPage, totalItems);

    return `${startCount}-${endCount} of ${totalItems}`;
  }

  const handlePageChange = (category, page) => {
    currentPages.value[category] = page;
  }

  return {
    currentPages,
    perPage,
    getPaginationCount,
    handlePageChange
  }
}